import React from 'react';

const Footer = () => {
  return (
    <section className="footer bg-[#1A1A1A]  w-full  lg:h-[492px] flex flex-col justify-center items-center overflow-x-hidden">
      <div className="lg:w-[1512px] lg:h-[492px] md:w-[834px] md:h-[367px] w-[394px] h-[501px] lg:px-[64px]   md:px-[64px]   mt-[96px] lg:mt-[120px] ">
        <div className="flex flex-wrap justify-between gap-y-10 px-6 text-left md:text-left lg:w-[1299px] lg:h-[148px] md:w-[706px] md:h-[135px] w-[362px] h-[376px] ">

          {/* Column 1 */}
          <div className="w-1/2 md:w-[183px] lg:w-[470px] ">
           <h3 className="text-white mb-4 text-[24px] leading-[100%] tracking-[0] font-outfit">
             <span className="font-semibold">Znorm</span>{' '}
             <span className="font-light">Homes</span>
           </h3>


            {/* <p className="font-[400] text-[16px] leading-[155%] tracking-[-0.03em] text-[#D0D0D0] font-open-sans">
  Discover the epitome of sophistication at Premium where every stay is a blend of opulence and personalized service. Immerse yourself in a world of Premium that transcends expectations.
</p> */}
 <p className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-open-sans  font-[400]">
              Discover the epitome of sophistication at Premium where every stay is a blend of opulence and personalized service. Immerse yourself in a world of Premium that transcends expectations.
            </p>
          </div>

          {/* Column 2 */} 

          <div className="w-1/2 md:w-[111px] lg:w-[158px] px-6">
            <h4 className=" text-white mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Company</h4>
            <ul className="space-y-2">
              <li><a href="/aboutus" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">About</a></li>
              <li><a href="/gallery" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Gallery</a></li>
              <li><a href="/blog" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Blog</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="w-1/2 md:w-[138px] lg:w-[154px] px-2">
            <h4 className=" text-white mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Information</h4>
            <ul className="space-y-2">
              <li><a href="/faq" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">FAQ</a></li>
              <li><a href="/" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Data Rights</a></li>
              <li><a href="/terms-of-use" className="text-[#D0D0D0] text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Terms</a></li>
            </ul>
          </div>  

          {/* Column 4 */}
          <div className="w-1/2 md:w-[160px] lg:w-[190px]  px-2 lg:px-0">
            <h4 className="text-white   mb-4 text-[18px] md:text-[20px] lg:text-[24px] font-outfit font-medium">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="tel:+918431276142"
                  className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400"
                >
                  Phone: <span className="text-[#D0D0D0]">+91 84312 76142</span>
                </a>
              </li>

              <li>
                <a
                  href="mailto:znormhomes@gmail.com"
                  className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400"
                >
                  Email: <span className="text-[#D0D0D0]">znormhomes@gmail.com</span> 
                </a>
              </li>

              <li className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350] hover:text-gray-400 ">Address: <span className="text-[#D0D0D0]">
                Znorm Hospitality,
                <br />
                Znorm Pvt Ltd,
                <br />
                Bhartiya City, 560064
                </span> </li>
            </ul>
          </div>

        </div>
      </div>
      <div className="w-full border-t border-gray-500 my-6 lg:w-[1512px] "></div>
      <div className="w-full px-4 md:px-[64px] lg:px-[107px] lg:max-w-[1512px] text-center text-white text-xs mb-6">
        © {new Date().getFullYear()} Znorm Homes. All Rights Reserved.
      </div>
    </section>
  );
};

export default Footer;